module.exports = __webpack_public_path__ + "img/bowler_hat_rolling.20ffb2b3.jpg";